import { useMutation } from "@tanstack/react-query";
import merchantUserService from "..";
import { CreateUserPayload } from "../type";

function useCreateMerchantUser() {
  return useMutation({
    mutationFn: (command: CreateUserPayload) => {
      return merchantUserService.addMerchantUser(command);
    },
  });
}

export default useCreateMerchantUser;
